import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Checkbox, Modal } from "antd";

import { handleloading } from "../Store/Redux/Reducers/Dashboardreducers";
import {
  DropdownService,
  EditAccessService,
  ViewUserService,
} from "../Services/ApiServices";
import { CatchMessage, JSONtoformdata, tokenisValid } from "../Shared/Methods";
import { HandleSessionModal } from "../Store/Redux/Reducers/Authreducers";
import Loader from "../SharedComponents/Loader/Loader";
import classes from "./Modal.module.css";
import CommonButton from "../Components/Buttons/CommonButton";
import CommonNodataFound from "../Components/CommonNodataFound";

function SettingsModal({
  onCancel,
  open,
  closable,
}: {
  onCancel: () => void;
  open: boolean;
  closable: boolean;
}) {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const { loading } = useSelector((state: any) => state.Dashboard);
  // const [UserData, SetUserData] = useState<any>();
  const [AlertValues, setAlertValues] = useState<any>([]);

  const dispatch = useDispatch();

  const [DropDowns, setDropDowns] = useState({
    AlertType: [],
  });

  useEffect(() => {
    if (LoginData?.token !== null) {
      getAlertTypeTypeDropDown();
    }
  }, [LoginData]);

  const getViewUser = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };
    ViewUserService(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status === 1) {
          // SetUserData(res?.data?.data);
          const AccessPermissions = res?.data?.data?.access_permissions;

          const splitData = AccessPermissions.split(",").map((ele: string) =>
            parseInt(ele)
          );

          setAlertValues(splitData);
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const getAlertTypeTypeDropDown = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      for_notification: 1,
    };
    DropdownService(JSONtoformdata(finalObj), "alertTypeDropdown")
      .then(async (res) => {
        if (res?.data?.status === 1) {
          const AlertType = res.data.data.map((ele: any, ind: number) => {
            return { value: ele?.key, label: ele?.description };
          });

          setDropDowns((pre) => {
            return {
              ...pre,
              AlertType: AlertType,
            };
          });
          getViewUser();
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const EditAccess = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      access_for: AlertValues,
    };
    EditAccessService(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status === 1) {
          toast.success(res?.data?.msg);
          onCancel();
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      {/* <Loader isLoader={loading} /> */}
      <Modal width={400} open={open} closable={closable} footer={null}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading} style={{ margin: 0 }}>
            Notification Settings
          </h4>
          {DropDowns?.AlertType?.length > 0 ? (
            <>
              <p
                style={{
                  // margin: 0,
                  fontSize: "11px",
                  color: "grey",
                  // display: "flex",
                  // justifyContent: "center",
                  marginTop: "-5px",
                }}
              >
                <span
                  style={{
                    color: "#ff8908",
                    fontSize: "14px",
                    marginTop: "-4px",
                  }}
                >
                  *
                </span>
                Only the selected options trigger an alert notification on your
                mobile.
              </p>

              <div className="notificationSettings">
                <Checkbox.Group
                  name="AlertValues"
                  options={DropDowns?.AlertType}
                  value={AlertValues}
                  onChange={(e) => {
                    setAlertValues(e);
                  }}
                />
              </div>
            </>
          ) : (
            <div className="mt-4">
              <CommonNodataFound />
            </div>
          )}

          <div className={classes.modal_button_container}>
            <CommonButton
              name="Submit"
              onClick={() => EditAccess()}
              type="submit"
              classname="submit_btn"
            />
            <CommonButton
              name="Cancel"
              type="button"
              onClick={() => {
                onCancel();
              }}
              // style={{ backgroundColor: "#eb3131" }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SettingsModal;
